import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';

// Guard (lang.guard.ts) handles translate.use() and waits for completion before activating.
// This resolver exists only to expose the lang param to child routes via route.snapshot.data['lang'].
export const langResolver: ResolveFn<boolean> = () => of(true);
